import { Toolbar } from '@mui/material';
import styled from 'styled-components';

export const DrawerToolbar = styled(Toolbar)`
  background-color: #0071bc;
  color: #000080 !important;
  box-shadow: rgba(25, 31, 40, 0.15) 0px 6px 24px 0px;
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
`;
